import React, { useState } from 'react';
import { Button, Modal, Row, Col, Typography, Space, Tabs, Divider, message } from 'antd';
import LoaderComponent from '../../../Loader';
import API from '../../../../services/API';

export default function SubscriptionPlans({ userId, refreshList }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [winbackOffers, setWinbackOffers] = useState(null);
  const [upgradeOffers, setUpgradeOffers] = useState(null);
  const [previewOffers, setPreviewOffers] = useState(null);
  const [acceptOffers, setAcceptOffers] = useState(null);
  const [previewOffersLoading, setPreviewOffersLoading] = useState(false);
  const [acceptOfferLoading, setAcceptOfferLoading] = useState(false);


  const getOffers = async () => {
    try {
      setLoading(true);
      const winbackOffer = await API.getSubscriptionWinback({ userId, annualUpgrade: false })
      setWinbackOffers(winbackOffer);

      const upgradeOffer = await API.getSubscriptionWinback({ userId, annualUpgrade: true })
      setUpgradeOffers(upgradeOffer);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const openModal = () => {
    setModalVisible(true);
    getOffers();
    setPreviewOffers(null);
    setAcceptOffers(null);
  };

  const closeModal = () => {
    setModalVisible(false);
    setWinbackOffers(null);
    setUpgradeOffers(null);
    setPreviewOffers(null);
    setAcceptOffers(null);
  };

  const getPreviewOffers = async (type, planId) => {
    try {
      setPreviewOffersLoading((prev) => prev ? { ...prev, [`${planId}-${type}`]: true } : { [`${planId}-${type}`]: true });
      const previewOffer = await API.getSubscriptionOffersPreview({ userId, planId, type: type.toUpperCase() })
      setPreviewOffers((prev) => {
        if (prev) {
          return {
            ...prev,
            [`${planId}-${type}`]: previewOffer
          }
        }
        return {
          [`${planId}-${type}`]: previewOffer
        }
      });
    } catch (error) {
      console.error(error);
    } finally {
      setPreviewOffersLoading((prev) => prev ? { ...prev, [`${planId}-${type}`]: false } : { [`${planId}-${type}`]: false });
    }
  }

  const acceptOffer = async (type, planId) => {
    try {
      setAcceptOfferLoading((prev) => prev ? { ...prev, [`${planId}-${type}`]: true } : { [`${planId}-${type}`]: true });
      const acceptOfferResponse = await API.getSubscriptionOffersAccept({ userId, planId, type: type.toUpperCase() });
      if (acceptOfferResponse.status === 'SUCCESS') {
        message.success(acceptOfferResponse.description);
        refreshList();
        closeModal();
      } else {
        message.error(acceptOfferResponse.error);
      }
      setAcceptOffers((prev) => {
        if (prev) {
          return {
            ...prev,
            [`${planId}-${type}`]: acceptOfferResponse
          }
        }
        return {
          [`${planId}-${type}`]: acceptOfferResponse
        }
      });
    } catch (error) {
      console.error(error);
    } finally {
      setAcceptOfferLoading((prev) => prev ? { ...prev, [`${planId}-${type}`]: false } : { [`${planId}-${type}`]: false });
    }
  }

  return (
    <>
      <Button type="primary" onClick={openModal}>
        View Offers
      </Button>

      <Modal
        title="Update Subscription Plan"
        visible={modalVisible}
        onCancel={closeModal}
        width={1000}
        footer={[
          <Button key="cancel" onClick={closeModal}>
            Close
          </Button>
        ]}
      >
        {
          loading && <LoaderComponent />
        }
        {
          !loading && <>
          <Tabs>
            <Tabs.TabPane tab="Winback Offers" key="winback">
              <Space direction="vertical" style={{ width: '100%' }}>
                {
                  winbackOffers?.plans?.length > 0 && winbackOffers.plans.map((offer) => (
                  <>
                    <Row key={`${offer.id}-winback`}>
                      <Col span={12}>
                        <Typography.Text strong>
                          <Typography.Text type="danger" delete>
                            {offer.originalPaymentTermText}
                          </Typography.Text>
                          &nbsp;{offer.billedText}<br/>
                        </Typography.Text>

                        <Typography.Paragraph>{offer.description}</Typography.Paragraph>
                        <Button size="small" type="primary" loading={previewOffersLoading?.[`${offer.id}-winback`]} onClick={() => getPreviewOffers('winback', offer.id)}>Preview</Button>
                          
                      </Col>
                      <Col span={12}>
                        {
                          previewOffers?.[`${offer.id}-winback`] && (
                            <div>
                              <Typography.Paragraph><strong>Subtotal:</strong> {previewOffers?.[`${offer.id}-winback`]?.chargeBreakdown?.subtotal}</Typography.Paragraph>
                              <Typography.Paragraph><strong>Credit for Unused Days:</strong> {previewOffers?.[`${offer.id}-winback`]?.chargeBreakdown?.creditForUnusedDays ?? '-'}</Typography.Paragraph>
                              <Typography.Paragraph>
                                <strong>Sales Tax:</strong> {previewOffers?.[`${offer.id}-winback`]?.chargeBreakdown?.salesTax ?? '-'}
                                {acceptOffers?.[`${offer.id}-winback`]?.status === 'SUCCESS' ? 
                                  <Button style={{ float: 'right' }} type="success">Charged</Button>
                                  : <Button style={{ float: 'right' }} loading={acceptOfferLoading?.[`${offer.id}-winback`]}  type="primary" onClick={() => acceptOffer('winback', offer.id)}>Charge</Button>}
                              </Typography.Paragraph>
                              <Typography.Paragraph>
                                <strong>Total:</strong> {previewOffers?.[`${offer.id}-winback`]?.chargeBreakdown?.total}
                              </Typography.Paragraph>
                              <Typography.Paragraph>{previewOffers?.[`${offer.id}-winback`]?.authorizationText}</Typography.Paragraph>
                            </div>
                          )
                        }
                      </Col>
                    </Row>
                    <Divider />
                  </>))
                }
              </Space>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Upgrade Offers" key="upgrade">
            {
                upgradeOffers?.plans?.length > 0 && upgradeOffers.plans.map((offer) => (
                  <Row key={`${offer.id}-upgrade`}>
                    <Col span={12}>
                      <Typography.Text strong>
                        <Typography.Text type="danger" delete>
                          {offer.originalPaymentTermText}
                        </Typography.Text>
                        &nbsp;{offer.billedText}<br/>
                      </Typography.Text>

                      <Typography.Paragraph>{offer.description}</Typography.Paragraph>
                      <Button size="small" type="primary" loading={previewOffersLoading?.[`${offer.id}-upgrade`]} onClick={() => getPreviewOffers('upgrade', offer.id)}>Preview</Button>
                  
                    </Col>
                    <Col span={12}>
                      {
                        previewOffers?.[`${offer.id}-upgrade`] && (
                          <div>
                            <Typography.Paragraph><strong>Subtotal:</strong> {previewOffers?.[`${offer.id}-upgrade`]?.chargeBreakdown?.subtotal}</Typography.Paragraph>
                            <Typography.Paragraph><strong>Credit for Unused Days:</strong> {previewOffers?.[`${offer.id}-upgrade`]?.chargeBreakdown?.creditForUnusedDays ?? '-'}</Typography.Paragraph>
                            <Typography.Paragraph>
                              <strong>Sales Tax:</strong> {previewOffers?.[`${offer.id}-upgrade`]?.chargeBreakdown?.salesTax ?? '-'}
                              <Button style={{ float: 'right' }} type="primary" onClick={() => acceptOffer('upgrade', offer.id)}>Charge</Button>
                            </Typography.Paragraph>
                            <Typography.Paragraph><strong>Total:</strong> {previewOffers?.[`${offer.id}-upgrade`]?.chargeBreakdown?.total}</Typography.Paragraph>
                            <Typography.Paragraph>{previewOffers?.[`${offer.id}-upgrade`]?.authorizationText}</Typography.Paragraph>
                          </div>
                        )
                      }
                    </Col>
                  </Row>
                ))
              }
            </Tabs.TabPane>
          </Tabs>
          </>
        }
      </Modal>
    </>
  )
}